export default "__VITE_ASSET__BYYXKpxG__"